export class ECaseNavigationModel {
  public model: any[];

  constructor(model) {
    this.model = model;
  }
}

